import React, { useContext, useEffect, useState } from 'react';
import { Container, Card, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';
import ProtectedSection from '../components/ProtectedSection';
import dailyRateService from '../services/dailyRateService';

export default function DailyRatePage() {
  const { hasRight } = useContext(AuthContext);
  const canView = hasRight('RATE_VIEW');
  const canUpdate = hasRight('RATE_UPDATE');

  const [rate, setRate] = useState(null);
  const [buyRateUsdHtg, setBuyRateUsdHtg] = useState('');
  const [sellRateUsdHtg, setSellRateUsdHtg] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const fetchRate = () => {
    if (!canView) return;
    setErr('');
    dailyRateService
      .get()
      .then((r) => {
        setRate(r);
        setBuyRateUsdHtg(r?.buyRateUsdHtg ?? r?.usdToHtg ?? '');
        setSellRateUsdHtg(r?.sellRateUsdHtg ?? r?.usdToHtg ?? '');
      })
      .catch(() => setErr('Erreur lors du chargement du taux du jour.'));
  };

  useEffect(fetchRate, [canView]);

  const save = () => {
    setMsg('');
    setErr('');
    dailyRateService
      .update({
        buyRateUsdHtg: Number(buyRateUsdHtg),
        sellRateUsdHtg: Number(sellRateUsdHtg),
      })
      .then((r) => {
        setRate(r);
        setBuyRateUsdHtg(r?.buyRateUsdHtg ?? '');
        setSellRateUsdHtg(r?.sellRateUsdHtg ?? '');
        setMsg('Taux mis à jour.');
      })
      .catch((e) => {
        setErr(e?.response?.data?.message || 'Erreur lors de la mise à jour du taux.');
      });
  };

  return (
    <Container className="pt-4">
      <h2>Taux du jour</h2>

      {msg && <Alert variant="success">{msg}</Alert>}
      {err && <Alert variant="danger">{err}</Alert>}

      <Card className="mt-3">
        <Card.Body>
          <div className="text-muted mb-3">
            Définissez les deux taux utilisés par les modules :
            <br />
            <strong>Achat</strong> = utilisé par Zelle et Exchange (achat)
            <br />
            <strong>Vente</strong> = utilisé par Exchange (vente)
          </div>

          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Taux achat : 1 USD = (HTG)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={buyRateUsdHtg}
                  onChange={(e) => setBuyRateUsdHtg(e.target.value)}
                  disabled={!canUpdate}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Taux vente : 1 USD = (HTG)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={sellRateUsdHtg}
                  onChange={(e) => setSellRateUsdHtg(e.target.value)}
                  disabled={!canUpdate}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="mt-3 text-muted small">
            Dernière mise à jour : {rate?.updatedAt ? new Date(rate.updatedAt).toLocaleString() : '—'}
            {rate?.updatedByUser?.username ? ` • par ${rate.updatedByUser.username}` : ''}
          </div>

          <ProtectedSection code="RATE_UPDATE">
            <Button className="mt-3" onClick={save}>
              Enregistrer
            </Button>
          </ProtectedSection>
        </Card.Body>
      </Card>
    </Container>
  );
}
